import Api from 'core/services/api'
import { TFreights } from 'core/services/models/freight'

const path = '/v1/packages'

export const findFreight = (query = {}) => {
  return Api.request<TFreights[]>({
    url: path,
    params: { ...query },
  })
}
